import styled from 'styled-components';

/** Mirrors BudgetProduct.styles Container / ImageContainer so nothing jumps when data arrives. */
const Row = styled.div`
  display: flex;
  align-items: flex-start;

  padding-bottom: 3rem;
`;

const ButtonCell = styled.div`
  flex-shrink: 0;

  width: 3.2rem;
  padding-top: 1rem;
`;

const ImageCell = styled.div`
  flex-shrink: 0;

  width: 25rem;
  height: 18rem;
`;

const Logo = styled.img`
  width: 22rem;
  height: 100%;
  margin-left: 1.2rem;

  object-fit: scale-down;
  object-position: center;
  opacity: 0.3;
`;

const TableCell = styled.div`
  flex-grow: 1;
`;

const Line = styled.div<{ columns: number }>`
  display: grid;
  grid-template-columns: repeat(${({ columns }) => columns}, 1fr);
  gap: 2rem;

  padding: 1.6rem 0;

  &:first-child {
    border-bottom: 0.1rem solid #e0e0e0;
  }
`;

export { ButtonCell, ImageCell, Line, Logo, Row, TableCell };
